import {RootLayout, RsnButton} from '@raison/ui-kit';
import React, {ReactNode} from 'react';

export interface FallbackComponentProps {
    title?: string;
    message?: ReactNode;
}

export const FallbackPage = ({
    title = 'Something went wrong',
    message = 'We couldn’t complete your request because of an unexpected error. Please try again later.',
}: FallbackComponentProps) => {
    const home = '/';
    const returnHome = () => {
        window.location.href = home;
    };

    return (
        <div className={'flex h-full flex-col'}>
            <div className={'grid h-16 shrink-0 place-items-center'}>
                <RootLayout.CompanyLogoImg width={62} height={64} />
            </div>
            <div className={'flex flex-1 flex-col gap-6 p-4 pb-8'}>
                <div className={'flex flex-1 flex-col items-center justify-center gap-6 text-center'}>
                    <FailureSymbol />
                    <div className={'grid gap-2'}>
                        <div className={'fv-heading-l text-neutral-100'}>{title}</div>
                        <div className={'fv-text-l-regular text-neutral-90'}>
                            <span className={'text-balance'}>{message}</span>
                        </div>
                    </div>
                </div>
                <RsnButton.Primary onClick={returnHome}>Return home</RsnButton.Primary>
            </div>
        </div>
    );
};

function FailureSymbol() {
    return (
        <figure className={'grid size-24 place-items-center rounded-full bg-danger-10 text-danger-30'}>
            <svg xmlns='http://www.w3.org/2000/svg' width='96' height='96' fill='currentColor'>
                <path d='m50.732 53.93 1.063-23.929h-8.189l1.17 23.93h5.956ZM43.5 61.747c0 2.287 1.914 4.254 4.254 4.254s4.254-1.968 4.254-4.254c0-2.34-1.914-4.307-4.254-4.307S43.5 59.407 43.5 61.747Z' />
            </svg>
        </figure>
    );
}
